import { makeStyles } from "@material-ui/core/styles";

// Fit-to-panel layout for the Add Play actions.
//
// The default card grid derives its height from card WIDTH (padding-top: 50%),
// while the panel it lives in derives its height from viewport HEIGHT. Those
// two scale independently, so on a wide display - a 4K monitor especially -
// the cards outgrow the panel and it scrolls. No fixed pixel trim can fix
// that, because it is a constant fighting a term that scales.
//
// This layout instead divides the panel's actual height: every card row gets
// an equal share, and the pulled-out bar gets exactly half a row (flex 1
// against the rows' 2). Nothing here is expressed in pixels, so it holds at
// any window size and for any number of action cards.
const dynamicActionsStyles = makeStyles((theme) => ({
	fitRoot: {
		height: "100%",
		width: "100%",
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(1),
		minHeight: 0
	},
	row: {
		display: "flex",
		flexDirection: "row",
		gap: theme.spacing(1),
		flex: "2 1 0",
		minHeight: 0
	},
	cell: {
		flex: "1 1 0",
		minWidth: 0
	},
	// Keeps a partial row's cards the same width as a full row's instead of
	// letting them stretch to fill the gap.
	spacer: {
		flex: "1 1 0",
		minWidth: 0
	},
	bar: {
		flex: "1 1 0",
		minHeight: 0
	},
	hint: {
		flex: "0 0 auto"
	}
}));

export default dynamicActionsStyles;
